// Login 2FA — screen flow constants (spec: Borderless_Login_2FA_Screen_Flows v3)

export const FLOWS = {
  FIRST_TIME: "A", // 2FA not set up: email OTP → mobile OTP → new password
  RETURNING: "B", // 2FA set up: mobile OTP only
};

export const STEPS = {
  VERIFY_EMAIL: "verify-email", // A3
  CHOOSE_CHANNEL: "choose-channel", // A4 / B2
  ENTER_OTP: "enter-otp", // A5 / A6 / B3
  LOCKED: "locked", // A7
  ALTERNATE_NUMBER: "alternate-number", // A8
  REQUEST_RECEIVED: "request-received", // A9
  NEW_PASSWORD: "new-password", // A10 / A11
  PASSWORD_UPDATED: "password-updated", // A12
};

export const CHANNELS = {
  SMS: "SMS",
  WHATSAPP: "WHATSAPP",
};

// Channel names the 2FA send-OTP / verify APIs expect (spelling matches the API)
export const API_CHANNEL = {
  EMAIL: "email_verification",
  MOBILE: "mobile_verification",
  WHATSAPP: "whatsapp_verification",
};

export const CHANNEL_LABELS = {
  [CHANNELS.SMS]: "SMS",
  [CHANNELS.WHATSAPP]: "WhatsApp",
};

export const OTP_LENGTH = 6;
export const MAX_OTP_ATTEMPTS = 3;
export const MAX_RESENDS = 3;

// How long a request-level error notice stays on screen
export const ERROR_DISPLAY_MS = 3000;
export const LOCK_MINUTES = 30;
export const REDIRECT_SECONDS = 3;

export const EMAIL_OTP = {
  resendSeconds: 120,
  validitySeconds: 10 * 60,
};

export const MOBILE_OTP = {
  resendSeconds: 120,
  validitySeconds: 5 * 60,
};

export const CALL_SLOTS = [
  "Weekdays, 10 AM – 1 PM",
  "Weekdays, 1 PM – 4 PM",
  "Weekdays, 4 PM – 7 PM",
  "Saturday, 10 AM – 1 PM",
];

export const CS_EMAIL = "customersuccess@stockal.com";
export const CS_PHONE = "+91-22-42792110";
